import * as types from './actionTypes';  
import attestationDspApi from '../api/attestationDspApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doAttestationDsp(data) {
  return {
    type: types.DO_ATTESTATION_DSP, 
    data
  };
}

export function doAttestationDspRes(data) {
  return {
    type: types.DO_ATTESTATION_DSP_RES, 
    data
  };
}

export function attestationDsp(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      attestationDspApi.doAttestationDsp(data).then(res => {
        dispatch(doAttestationDspRes(res));
        dispatch(loadingRes(false));
        if(res.error){
          Swal.fire({
            title: res.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}